import * as Sentry from '@sentry/gatsby';
import { sentryConfigActivationJoinAffiliateClub } from '@agria/utils/src/sentryConfigActivationJoinAffiliateClub';

Sentry.init(sentryConfigActivationJoinAffiliateClub);
